var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"id":_vm.id,"value":_vm.value,"options":_vm.platformOptions},on:{"change":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{directives:[{name:"translate",rawName:"v-translate"}],domProps:{"value":null}},[_vm._v("None")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }